import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import { graphql } from 'gatsby';
import PageWrapper from 'components/molecules/PageWrapper/PageWrapper';
import PageHeader from 'components/atoms/PageHeader/PageHeader';
import SpanText from 'components/atoms/SpanText/SpanText';
import { pageTimeline, eduPageTimeline } from 'utils';

const StyledListWrapper = styled.div`
 display: flex;
  flex-direction: column; 
  gap: 20px;
  width: 100%;
  align-items: start;
  justify-content: center;
  margin: 20px 0;

  div {
    margin: auto;
    display: grid;
    width: 80%;
    grid-template-rows: 60px 40px minmax(40px, auto);
    grid-template-columns: 80px 200px 1fr;

    ${({ theme }) => theme.mqx.phone} {
      grid-template-columns: 30px 200px 1fr;
    }
  }
`;

const StyledInnerHeader = styled.h2`
  display: block;
  grid-row: 1 / span 2;
  grid-column: 1 / span 2;
  max-width: 100%;
  height: auto;
  font-weight: ${({ theme }) => theme.font.weight.regular};
  background-color: ${({ theme }) => theme.white};
  border: 2px solid ${({ theme }) => theme.borders};
  text-align: left;
  color: ${({ theme }) => theme.black};
  padding: 20px 15px;
  letter-spacing: 3px;
  text-transform: uppercase;
  ${({ theme }) => theme.mqx.phone} {
    font-size: ${({ theme }) => theme.font.size.paragraph};
  }
`;

const StyledSpanText = styled(SpanText)`
  display: flex;
  flex-direction: column;
  grid-row: 2 / span 2;
  grid-column: 2 / span 2;
  width: 100%;
  height: 100%;
  border: 5px solid ${({ theme }) => theme.white};
  background-color: ${({ theme }) => theme.primary};
  text-align: left;
  padding: 20px;
  letter-spacing: 3px;
  font-size: ${({ theme }) => theme.font.size.paragraph};

  ${({ theme }) => theme.mqx.phone} {
    font-size: ${({ theme }) => theme.font.size.maslowSml};
  }

`;



const EducationPage = ({ data }) => {
  const headRef = useRef(null);
  const wrapRef = useRef(null);
  const gridsRef = useRef(null);

  useEffect(() => {
    pageTimeline(headRef, wrapRef, eduPageTimeline(gridsRef));
  }, []);


  const parsedEducation = JSON.parse(data.datoCmsEducation.education);

  const parseDescriptionToLines = (desc) => {
    if (typeof desc !== 'string') return null;
    if (!desc.includes('\n')) return null;
    return desc
      .split('\n')
      .map((line) => line.trim())
      .filter(Boolean);
  };

  return (
    <>
      <PageHeader ref={headRef}>kwalifikacje</PageHeader>
      <PageWrapper ref={wrapRef}>
        <StyledListWrapper ref={gridsRef}>
          {parsedEducation.map((item) => {
            const lines = parseDescriptionToLines(item.description);
            return (
              <div key={item.id}>
                <StyledInnerHeader>{item.title}</StyledInnerHeader>
                {lines ? (
                  <StyledSpanText>
                      {lines.map((line, idx) => (
                        <p key={idx}>{line}</p>
                      ))}
                  </StyledSpanText>
                ) : (
                  <StyledSpanText>{item.description}</StyledSpanText>
                )}
              </div>
            );
          })}
        </StyledListWrapper>
      </PageWrapper>
    </>
  );
};

export const query = graphql`
  {
    datoCmsEducation {
      education
    }
  }
`;

export default EducationPage;
